import { BASE_URL } from "./backendData";
import { supabase } from "../supabaseClient";

const loadUserData = async (userId) => {
  const response = await fetch(`${BASE_URL}/loadUser/${userId}`);
  const userData = await response.json();
  return userData;
};

const modifyUserData = async (userId, user_data) => {
  const response = await fetch(`${BASE_URL}/modifyUser/${userId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_data }),
  });
  return await response.json();
};


const listRestaurants = async () => {
  // Request all rows in one round-trip. Backend default is 20/page so
  // without this we'd only ever show page 1 on the Discover screen.
  // 500 is the current backend cap — safe ceiling for the ~100 live
  // rows and leaves headroom as the directory grows.
  const response = await fetch(`${BASE_URL}/listRestaurants?per_page=500`);
  const restaurantData = await response.json();
  return restaurantData;
};

const startChat = async (user_id, restaurant_id, force_new) => {

  user_id = parseInt(user_id);
  restaurant_id = parseInt(restaurant_id);

  const response = await fetch(`${BASE_URL}/startChat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id, restaurant_id, force_new }),
  });
  return await response.json();
}

const sendMessage = async (chat_id, message) => {
  const response = await fetch(`${BASE_URL}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ chat_id, message })
  });
  return await response.json();
}

const submitReview = async (user_id, restaurant_id, chat_id, item, rating, review_text) => {
  const response = await fetch(`${BASE_URL}/submitReview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id, restaurant_id, chat_id, item, rating, review_text })
  });
  return await response.json();
}

const loadUserPreferences = async (user_id, restrictionType) => {
  const response = await fetch(`${BASE_URL}/loadUserPreferences/${user_id}/${restrictionType}`);
  const data = await response.json();
  return data;
}

const saveUserPreferences = async (user_id, dietary_restrictions, restrictionType) => {
  const response = await fetch(`${BASE_URL}/saveUserPreferences/${user_id}/${restrictionType}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ dietary_restrictions })
  });
  const data = await response.json();
  return data;
}

const saveUserPrefrencesAudio = async (user_id, audioBlob) => {
  const formData = new FormData();
  console.log("Received audio blob", audioBlob);
  formData.append('audio_file', audioBlob)
  console.log("formData", formData)
  const response = await fetch(`${BASE_URL}/saveUserPreferencesAudio/${user_id}`, {
    method: 'POST',
    body: formData,
  });
  const data = await response.json();
  return data;
}

const listUserRestaurantReviews = async (user_id, restaurant_id) => {
  const response = await fetch(`${BASE_URL}/reviews/${user_id}/${restaurant_id}`)
  const data = await response.json();
  return data; 
}

const editUserRestaurantReviews = async (user_id, restaurant_id, reviews) => {
  const response = await fetch(`${BASE_URL}/reviews/${user_id}/${restaurant_id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ reviews })
  });
  const data = await response.json(); 
  return data;
}

const genImageDish = async(restaurantId, dishName) => {
  const response = await fetch(`${BASE_URL}/imagegen/dish/${restaurantId}/${dishName}`)
  const data = await response.json();
  return data;
}

const menuItemsFromChat = async(chatId) => {
  const response = await fetch(`${BASE_URL}/chat/${chatId}/menu_items`)
  const data = await response.json();
  return data;
}

const createRestaurant = async(restaurantData) => {
  const response = await fetch(`${BASE_URL}/restaurant`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(restaurantData)
  });
  const data = await response.json(); 
  return data;
}

const deleteRestaurant = async (userId, restaurantId) => {
  const response = await fetch(`${BASE_URL}/restaurant/${restaurantId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({user_id: userId})
  });
  const data = await response.json();
  return data;
};

// Get full restaurant data including menus and documents
const getRestaurant = async (restaurantId) => {
  const response = await fetch(`${BASE_URL}/restaurant/${restaurantId}`);
  const data = await response.json();
  return data;
};

// Update restaurant profile (name, address, description)
const updateRestaurant = async (restaurantId, updates, userId) => {
  const response = await fetch(`${BASE_URL}/restaurant/${restaurantId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...updates, user_id: userId })
  });
  const data = await response.json();
  return data;
};

// Update a specific menu's data
const updateRestaurantMenu = async (restaurantId, menuId, menuData) => {
  const response = await fetch(`${BASE_URL}/restaurant/${restaurantId}/menu/${menuId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ document_data: { menu_data: menuData } })
  });
  const data = await response.json();
  return data;
};

// Add a new menu to restaurant
const addRestaurantMenu = async (restaurantId, menuData) => {
  const response = await fetch(`${BASE_URL}/restaurant/${restaurantId}/menu`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ restaurant_id: restaurantId, menu_data: menuData })
  });
  const data = await response.json();
  return data;
};

// Get audit history for a restaurant
const getAuditHistory = async (restaurantId, queryParams = '') => {
  // Get Supabase session token for authentication
  const session = await supabase.auth.getSession();
  const token = session?.data?.session?.access_token;

  if (!token) {
    throw new Error('No authentication token available');
  }

  const response = await fetch(
    `${BASE_URL}/restaurant/${restaurantId}/audit?${queryParams}`,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch audit history: ${response.statusText}`);
  }

  return response.json();
};

// Helper function to get auth token
const getAuthToken = async () => {
  const session = await supabase.auth.getSession();
  const token = session?.data?.session?.access_token;
  if (!token) {
    throw new Error('No authentication token available');
  }
  return token;
};

// Create a new order
const createOrder = async (orderData) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/orders`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(orderData)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create order');
  }

  return response.json();
};

// Add item to order
const addOrderItem = async (orderId, itemData) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/orders/${orderId}/items`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(itemData)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to add item to order');
  }

  return response.json();
};

// Get order details
const getOrder = async (orderId) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/orders/${orderId}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to get order');
  }

  return response.json();
};

// Submit order (change status from pending to submitted)
const submitOrder = async (orderId) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/orders/${orderId}/submit`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to submit order');
  }

  return response.json();
};

// Get user's orders
const getUserOrders = async () => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/orders`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to get orders');
  }

  return response.json();
};

// Create payment intent with Stripe
const createPaymentIntent = async (paymentData) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/payments/create-intent`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(paymentData)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create payment intent');
  }

  return response.json();
};

// Confirm payment after Stripe confirmation
const confirmPayment = async (paymentId, confirmData) => {
  const token = await getAuthToken();
  const response = await fetch(`${BASE_URL}/payments/${paymentId}/confirm`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(confirmData)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to confirm payment');
  }

  return response.json();
};

const dataService = {
  loadUserData,
  modifyUserData,
  listRestaurants,
  startChat,
  sendMessage,
  loadUserPreferences,
  saveUserPreferences,
  submitReview,
  saveUserPrefrencesAudio,
  listUserRestaurantReviews,
  editUserRestaurantReviews,
  genImageDish,
  menuItemsFromChat,
  createRestaurant,
  deleteRestaurant,
  getRestaurant,
  updateRestaurant,
  updateRestaurantMenu,
  addRestaurantMenu,
  getAuditHistory,
  createOrder,
  addOrderItem,
  getOrder,
  submitOrder,
  getUserOrders,
  createPaymentIntent,
  confirmPayment,

  // ===========================================================================
  // Stubs for unified C-tier screens that have their own graceful demo
  // fallbacks. Each returns an empty list / null / rejects, so the screen's
  // try/catch path hits the demo state instead of crashing on undefined().
  //
  // When the real backend endpoints land (SafetySignal, Notifications,
  // MyTable social graph, Rewards ledger, Owner analytics, etc.), swap
  // these stubs for real fetch() implementations — the screens are
  // already wired to handle success.
  // ===========================================================================
  listSafetySignals:       async () => { return []; },
  createSafetySignal:      async () => { throw new Error('createSafetySignal: backend not wired yet'); },
  listRestaurantReviews:   async () => { return []; },
  listNotifications:       async () => { return []; },
  markNotificationRead:    async () => { throw new Error('markNotificationRead: backend not wired yet'); },
  dismissNotification:     async () => { throw new Error('dismissNotification: backend not wired yet'); },
  markAllNotificationsRead:async () => { throw new Error('markAllNotificationsRead: backend not wired yet'); },
  getMyTableConnections:   async () => { return []; },
  getMyTableInvites:       async () => { return []; },
  getMyTableSuggestions:   async () => { return []; },
  sendMyTableInvite:       async () => { throw new Error('sendMyTableInvite: backend not wired yet'); },
  acceptMyTableInvite:     async () => { throw new Error('acceptMyTableInvite: backend not wired yet'); },
  declineMyTableInvite:    async () => { throw new Error('declineMyTableInvite: backend not wired yet'); },
  listTableQuestions:      async () => { return []; },
  createTableQuestion:     async () => { throw new Error('createTableQuestion: backend not wired yet'); },
  answerTableQuestion:     async () => { throw new Error('answerTableQuestion: backend not wired yet'); },
  getRewardsOverview:      async () => { return null; },
  redeemReward:            async () => { throw new Error('redeemReward: backend not wired yet'); },
  getOwnerAnalytics:       async () => { return null; },
  advanceOrder:            async () => { throw new Error('advanceOrder: backend not wired yet'); },
  cancelOrder:             async () => { throw new Error('cancelOrder: backend not wired yet'); },
  payOrder:                async () => { throw new Error('payOrder: backend not wired yet'); },
  searchRestaurants:       async (filters = {}) => {
    // Delegates to listRestaurants with simple client-side filter — keeps
    // the unified discover screen usable until the backend adds a real
    // search endpoint. Matches the shape the unified screen expects.
    const all = await listRestaurants();
    return { restaurants: all, total: all.length, total_pages: 1 };
  },
};

export default dataService;
